export const GENERIC_EVENT_TYPE_FILTER_VALUE = 'GENERIC';
//# sourceMappingURL=generic-event-type-filter-value.js.map